import React, { useEffect, useCallback, useState } from 'react';
import { useLocation, useNavigate } from "react-router";
import { useTranslation } from 'react-i18next';
import { AxiosError } from 'axios';
import { Location } from 'history';
import { callAlertWeb, callNativeWeb, footerShowEventWeb } from 'common/appInterface';
import client from 'lib/CommonApi/client';
import { getVersionUrl } from 'common/cacheOverwrite';

const ApplyCompletPage: React.FC = () => {
  /** Location State */
  const location = useLocation() as Location<LocationState>;
  /** Navigate */
  const navigate = useNavigate();
  /** 다국어처리 */
  const { t, i18n } = useTranslation();

  const screenId = "APPL16";
  const screenName = t("APPL16.title");

  const [cardApply] = useState<Partial<CardApplyCommon>>(location.state.apply);

  /** 뒤로가기 처리 (backKeyEvent_App (APP > WEB)) */
  const callbackBackkeyEvent = useCallback(() => {
    navigate("/main", { state: { query: location.state.query, swiperIndex: 0, tabIndex: "1" }});
  }, [navigate, location]);

  /** 신청완료 후처리 호출 */
  const callComplet = useCallback(async () => {
    await client.patch("/api/app/apply/complet", { ...location.state.query, receiveSeq: cardApply.receiveSeq, receiveDate: cardApply.receiveDate }).then((response) => {
      let result = response.data.response;
      console.log(result);
    }).catch((e: AxiosError) => {
      callAlertWeb("ERROR", "99", e.message);
    });
  }, [location, cardApply]);

  // 최초실행
  useEffect(() => {
    // 언어설정
    i18n.changeLanguage(location.state.query.languageCode);
    // callNative_Web 처리 (WEB > APP)
    callNativeWeb(screenId, screenName);
    // 하단바 숨기기
    footerShowEventWeb("N");

    console.log("QUERY STATE");
    console.log(location.state);

    callComplet();

    // 최초한번실행 useEffect() Warning 제거
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 뒤로가기 이벤트 리스너 (backKeyEvent_App (APP > WEB))
  useEffect(() => {
    document.addEventListener("backpress", callbackBackkeyEvent);
    return () => document.removeEventListener("backpress", callbackBackkeyEvent);
  }, [callbackBackkeyEvent]);

  return (
    <div id="wrap">
      <div id="container" className="pcHidden">
        <section className="contents notification2 pb64-mb">
          <div className="inner">
            <div className="applyInfoWrap">
              <p className="mainTxt">{t("APPL16.explan01")}</p>
              <div className="picto">
                <img src={getVersionUrl("/assets/images/content/sign-up.gif")} alt="성공" />
              </div>
              {/*<p className="subTxt">{t("APPL16.explan02")}</p>*/}
              <p className="noticeTxt">{t("APPL16.explan03")}</p>
              <p className="noticeTxt">{t("APPL16.explan04")}<br />{t("APPL16.explan05")}</p>
            </div>
            <div className="info">
              <p>{t("APPL16.explan06")}</p>
              <p><span>1670-4565</span></p>
            </div>
          </div>
        </section>
        <div className="btnArea">
          <div className="btnWrapTy01">
            <button type="button" className="btnPrimaryTy01" onClick={() => {
              /** PREMIER, DREAM CARD인 경우 Covid Event View */
              if (cardApply.cardProductCode === "103079" ) {
                navigate("/main", { state: { query: location.state.query, swiperIndex: 0, tabIndex: "1" }});
              } else {
                navigate("/apply/complet/" + cardApply.cardProductCode, { state: { query: location.state.query, swiperIndex: 0, tabIndex: "1" }});
              }
            }}><span>{t("COMMON.button.done")}</span></button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplyCompletPage;